import type { ReactNode } from 'react';

/**
 * A fieldset `<legend>` with an optional aside (a "?" help tip) after it on the
 * same line. The aside is never inside the `<legend>`, so the group's accessible
 * name stays exactly the legend text. With no aside this renders the plain legend
 * it always was. With one, the legend and the aside float side by side and a
 * zero-height spacer clears them, so the fieldset's next child lays out as before.
 */
export function LegendWithAside({
  aside,
  className,
  id,
  children,
}: {
  aside?: ReactNode;
  className?: string;
  id?: string;
  children: ReactNode;
}) {
  if (!aside) {
    return (
      <legend id={id} className={className}>
        {children}
      </legend>
    );
  }
  return (
    <>
      <legend id={id} className={`float-left ${className ?? ''}`.trim()}>
        {children}
      </legend>
      <span className="float-left !mt-0 ml-1.5 inline-flex h-5 items-center">{aside}</span>
      <span aria-hidden="true" className="clear-both block !mt-0" />
    </>
  );
}
